import { MISSION_STATUS_ENUM } from './../../shared/constants'

export const GET_AMBASSADOR_BY_ID = 'GET_AMBASSADORS_BY_ID'
export const RESSET_AMBASSADOR_DATA = 'RESSET_AMBASSADOR_DATA'
export const GET_AMBASSADOR_DOCUMENTS_BY_ID = 'GET_AMBASSADOR_DOCUMENTS_BY_ID'
export const GET_AMBASSADORS_BY_CITY_ID = 'GET_AMBASSADORS_BY_CITY_ID'

export const CREATE_AMBASSADOR_DOCUMENTS_BY_ID =
  'CREATE_AMBASSADOR_DOCUMENTS_BY_ID'
export const CREATE_AMBASSADOR_DOCUMENTS_BY_ID_SUCCESS =
  'CREATE_AMBASSADOR_DOCUMENTS_BY_ID_SUCCESS'

export const GET_AMBASSADORS_BY_CITY_ID_ERROR =
  'GET_AMBASSADORS_BY_CITY_ID_ERROR'
export const GET_AMBASSADOR_BY_ID_SUCCESS = 'GET_AMBASSADOR_BY_ID_SUCCESS'
export const GET_AMBASSADOR_DOCUMENTS_BY_ID_SUCCESS =
  'GET_AMBASSADOR_DOCUMENTS_BY_ID_SUCCESS'

export const GET_AMBASSADORS_BY_CITY_ID_SUCCESS =
  'GET_AMBASSADORS_BY_CITY_ID_SUCCESS'
export const UPDATE_AMBASSADOR_BY_ID = 'UPDATE_AMBASSADOR_BY_ID'
export const UPDATE_AMBASSADOR_BY_ID_SUCCESS = 'UPDATE_AMBASSADOR_BY_ID_SUCESS'
export const UPDATE_AMBASSADOR_BY_ID_GRAPH_QL =
  'UPDATE_AMBASSADOR_BY_ID_GRAPH_QL'
export const UPDATE_AMBASSADOR_BY_ID_GRAPH_QL_SUCCESS =
  'UPDATE_AMBASSADOR_BY_ID_GRAPH_QL_SUCCESS'
export const UPDATE_AMBASSADOR_BY_ID_GRAPH_QL_ERROR =
  'UPDATE_AMBASSADOR_BY_ID_GRAPH_QL_ERROR'
export const DELETE_AMBASSADOR_BY_ID = 'DELETE_AMBASSADOR_BY_ID'
export const DELETE_AMBASSADOR_BY_ID_SUCCESS = 'DELETE_AMBASSADOR_BY_ID_SUCCESS'

export const UPLOAD_AMBASSADOR_DOCUMENT = 'UPLOAD_AMBASSADOR_DOCUMENT'
export const UPLOAD_AMBASSADOR_DOCUMENT_SUCCESS =
  'UPLOAD_AMBASSADOR_DOCUMENT_SUCCESS'

export const SET_AMBASSADORS_BY_CITY_ID_FILTER_STATUS =
  'SET_AMBASSADORS_BY_CITY_ID_FILTER_STATUS'
export const SET_AMBASSADORS_BY_CITY_ID_FILTER_CARRYING =
  'SET_AMBASSADORS_BY_CITY_ID_FILTER_CARRYING'

export const SET_INVENTORY_BY_CLIENT_ID = 'SET_INVENTORY_BY_CLIENT_ID'

export const SET_AMBASSADORS_BY_CITY_ID_SORT_BY =
  'SET_AMBASSADORS_BY_CITY_ID_SORT_BY'

export const SET_INVENTORY_BY_CLIENT_ID_SORT_BY =
  'SET_INVENTORY_BY_CLIENT_ID_SORT_BY'

export const SET_AMBASSADORS_BY_CITY_ID_SEARCH_VALUE =
  'SET_AMBASSADORS_BY_CITY_ID_SEARCH_VALUE'
export const SET_ACTIVITY_FILTER_STATUS = 'SET_ACTIVITY_FILTER_STATUS'
export const SET_ACTIVITIES_SORT_BY = 'SET_ACTIVITIES_SORT_BY'

export const GET_AMBASSADOR_ACTIVITIES = 'GET_AMBASSADOR_ACTIVITIES'
export const GET_AMBASSADOR_ACTIVITIES_SUCCESS =
  'GET_AMBASSADOR_ACTIVITIES_SUCCESS'

export const SET_AMBASSADOR_STATUS = 'SET_AMBASSADOR_STATUS'

export const GET_AMBASSADOR_BY_ID_GRAPH_QL = 'GET_AMBASSADORS_BY_ID_GRAPH_QL'
export const GET_AMBASSADOR_BY_ID_GRAPH_QL_SUCCESS =
  'GET_AMBASSADOR_BY_ID_GRAPH_QL_SUCCESS'
export const GET_AMBASSADOR_BY_ID_GRAPH_QL_FAILURE =
  'GET_AMBASSADOR_BY_ID_GRAPH_QL_FAILURE'

export const GET_AMBASSADORS_BY_CITY_ID_GRAPH_QL =
  'GET_AMBASSADORS_BY_CITY_ID_GRAPH_QL'
export const GET_AMBASSADORS_BY_CITY_ID_GRAPH_QL_SUCCESS =
  'GET_AMBASSADORS_BY_CITY_ID_GRAPH_QL_SUCCESS'
export const GET_AMBASSADORS_BY_CITY_ID_GRAPH_QL_FAILURE =
  'GET_AMBASSADORS_BY_CITY_ID_GRAPH_QL_FAILURE'

export const AMBASSADOR_STATUS_KEY = {
  ACTIVE: 'active',
  PENDING: 'pending',
  PRE_ACCESS: 'pre_access',
  TERMINATING: 'terminating',
  BLOCKED: 'blocked',
  DELETED: 'deleted',
  WAITING_FOR_REVIEW: 'waiting_for_review',
}

export const AMBASSADOR_STATUS_LABEL = {
  [AMBASSADOR_STATUS_KEY.ACTIVE]: 'Active',
  [AMBASSADOR_STATUS_KEY.PENDING]: 'Pending',
  [AMBASSADOR_STATUS_KEY.PRE_ACCESS]: 'Pre access',
  [AMBASSADOR_STATUS_KEY.TERMINATING]: 'Terminating',
  [AMBASSADOR_STATUS_KEY.BLOCKED]: 'Blocked',
  [AMBASSADOR_STATUS_KEY.DELETED]: 'Deleted',
  [AMBASSADOR_STATUS_KEY.WAITING_FOR_REVIEW]: 'Waiting for review',
}

export const AMBASSADOR_STATUS = [
  {
    label: 'N/A',
    value: null,
  },
  {
    label: AMBASSADOR_STATUS_LABEL[AMBASSADOR_STATUS_KEY.ACTIVE],
    value: AMBASSADOR_STATUS_KEY.ACTIVE,
  },
  {
    label: AMBASSADOR_STATUS_LABEL[AMBASSADOR_STATUS_KEY.PENDING],
    value: AMBASSADOR_STATUS_KEY.PENDING,
  },
  {
    label: AMBASSADOR_STATUS_LABEL[AMBASSADOR_STATUS_KEY.TERMINATING],
    value: AMBASSADOR_STATUS_KEY.TERMINATING,
  },
  {
    label: AMBASSADOR_STATUS_LABEL[AMBASSADOR_STATUS_KEY.BLOCKED],
    value: AMBASSADOR_STATUS_KEY.BLOCKED,
  },
  {
    label: AMBASSADOR_STATUS_LABEL[AMBASSADOR_STATUS_KEY.DELETED],
    value: AMBASSADOR_STATUS_KEY.DELETED,
  },
  {
    label: AMBASSADOR_STATUS_LABEL[AMBASSADOR_STATUS_KEY.WAITING_FOR_REVIEW],
    value: AMBASSADOR_STATUS_KEY.WAITING_FOR_REVIEW,
  },
]

export const AMBASSADOR_NA_EXCLUDES = [
  AMBASSADOR_STATUS_KEY.DELETED,
  AMBASSADOR_STATUS_KEY.PENDING,
  AMBASSADOR_STATUS_KEY.BLOCKED,
]

export const AMBASSADOR_STATUSES = {
  pending: 0,
  active: 1,
  blocked: 2,
  terminating: 5,
  waiting_for_review: 6,
}

export const ACTIVITY_STATUS = {
  ALL: null,
  ACCEPTED: [MISSION_STATUS_ENUM.BOOKED, MISSION_STATUS_ENUM.CHECKED_IN],
  COMPLETED: [
    MISSION_STATUS_ENUM.COMPLETED,
    MISSION_STATUS_ENUM.UNDER_REVIEW,
    MISSION_STATUS_ENUM.PAID,
  ],
}

export const AMBASSADOR_CARRYING = [
  {
    label: 'N/A',
    value: 'n/a',
  },
  {
    label: 'Yes',
    value: 'yes',
  },
  {
    label: 'No',
    value: 'no',
  },
]

export const DATA_TYPES = {
  INVENTORY: 'inventory',
  ACTIVITY: 'activity',
}

export const BLOCK_AMBASSADOR_REASON_OTHER = 'Other'

export const BLOCK_AMBASSADOR_REASON_OPTIONS = [
  'Always late to missions',
  'Always cancelling',
  'Bad attitude',
  'Late to interview',
  'No longer interested in job',
  'Not presentable',
  'Poor English ability',
  'Poor interaction (i.e too shy/disinterested)',
  'Poor organisation (i.e constantly picks wrong code, turns up with incorrect inventory, no show for pickups)',
  'Poor results',
  'Poor spy feedback',
  'Relocated away',
  BLOCK_AMBASSADOR_REASON_OTHER,
]



// WEBPACK FOOTER //
// ./src/Reducers/Ambassador/const.js